exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dz-default,.dz-message{font-family:Microsoft JhengHei,Verdana,Heiti TC,sans-serif!important}.dropzone-custom-content{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);text-align:center}.dz-message .dropzone-custom-title{margin-top:0;color:#00b782}.dz-message .subtitle{color:#314b5f}.dz-started .dropzone-custom-content{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c1b23f3","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Uploader/UploadZone.vue
// module id = nSwB
// module chunks = 0 1 3 4 5 6 7 8 9